import { put, takeEvery, select } from 'redux-saga/effects';

import { HIDE_RECOMMENDATION } from 'actionTypes';

import {
  removeRecommendationFromList,
  updateRecommendationStatus,
  setHidingRecommendation,
} from 'actions';

function* hidingRecommendationSaga(action) {
  const hidingRecommendation = yield select(
    state => state.hidingRecommendation
  );
  const { recommendation } = action;
  const payload = { is_hidden: !recommendation.is_hidden };
  if (hidingRecommendation) {
    yield put(removeRecommendationFromList(hidingRecommendation));
  }
  if (!recommendation.is_hidden) {
    yield put(setHidingRecommendation(recommendation.uuid));
  }
  yield put(updateRecommendationStatus(recommendation.uuid, payload));
}

export default [takeEvery(HIDE_RECOMMENDATION, hidingRecommendationSaga)];



// WEBPACK FOOTER //
// ./src/sagas/recommendationHidingSagas.js